/**
 * The sidebar, as the prototype draws it: the whole admin, grouped.
 *
 * Items are of two kinds, and the difference is the point of this file.
 *
 *   - `to`   — a page that has been rebuilt. Routed inside the new tree.
 *   - `href` — a page that has not. A plain link out to the old admin, which
 *              leaves this tree with a full page load, styles and all.
 *
 * Listing the unbuilt pages rather than hiding them keeps the shell honest and
 * usable from the first day: somebody working in here can still reach anything,
 * and what is left to do is visible instead of tracked in someone's head.
 * Rebuilding a page is then a one-line change — `href` becomes `to`.
 *
 * The labels and grouping follow the old admin's own sidebar, so muscle memory
 * survives the rewrite.
 */
export default [
  { group: null, items: [
    { label: 'Home', icon: '⌂', to: 'home' },
    { label: 'Overview', icon: '▣', to: 'overview' },
    { label: 'Signups', icon: '✎', to: 'signups' },
    { label: 'Emails', icon: '✉', to: 'emails' },
    { label: 'Booking Agreements', icon: '▭', to: 'booking-agreements' }
  ] },

  { group: 'People', items: [
    { label: 'Users', icon: '◔', to: 'users' },
    { label: 'Participants', icon: '⛁', to: 'participants' }
  ] },

  { group: 'Money', items: [
    { label: 'Purchases', icon: '⛃', to: 'purchases' },
    { label: 'Transactions', icon: '⇄', to: 'transactions' },
    { label: 'Payment Methods', icon: '▤', to: 'payment-methods' },
    { label: 'Subscriptions', icon: '↻', to: 'subscriptions' },
    { label: 'Reports', icon: '▦', to: 'reports' }
  ] },

  { group: 'Courts', items: [
    { label: 'Seasonal Courts', icon: '▥', to: 'seasonal-courts' },
    { label: 'Seasonal Courts Overview', icon: '▤', to: 'seasonal-courts-overview' },
    { label: 'Seasonal Court Purchases', icon: '▦', to: 'seasonal-court-purchases' },
    { label: 'Products', icon: '▧', to: 'products' },
    { label: 'Activities', icon: '◈', to: 'activities' }
  ] },

  { group: 'Network', items: [
    { label: 'Providers', icon: '⚿', to: 'providers' },
    { label: 'Provider Admin', icon: '⚿', to: 'provider-admin' },
    { label: 'Facilities', icon: '▣', to: 'facilities' },
    { label: 'Non Partner Facilities', icon: '▤', to: 'non-partner-facilities' },
    { label: 'Areas', icon: '◇', to: 'areas' },
    { label: 'Facility Redirects', icon: '↗', to: 'facility-redirects' }
  ] },

  { group: 'System', items: [
    { label: 'SEO Texts', icon: 'ℹ', to: 'seo-texts' },
    { label: 'Facility Texts', icon: 'ℹ', to: 'facility-texts' },
    { label: 'Resource groups', icon: '⋮', to: 'resource-groups' },
    { label: 'Integrations', icon: '</>', to: 'integrations' },
    { label: 'Crawlings', icon: '✳', to: 'crawlings' },
    { label: 'Device Jobs', icon: '▯', to: 'device-jobs' },
    { label: 'Relay Rules', icon: '</>', to: 'relay-rules' },
    { label: 'Lockers', icon: '⚿', to: 'lockers' },
    { label: 'Salto Master Codes', icon: '⌗', to: 'salto-master-codes' },
    { label: 'Play', icon: '▷', to: 'play' },
    { label: 'Play Events', icon: '◷', to: 'play-events' },
    { label: 'Ambassador Applications', icon: '☆', to: 'ambassador-applications' },
    { label: 'Maintenance', icon: '⚒', to: 'maintenance' },
    { label: 'Design', icon: '◑', to: 'design' }
  ] }
];
